.pattern {
  background-color: #E7EBF7 !important;
  opacity: 1;
  /* color: #3a4e64; */
  background-size: 34.64px 20px !important;
  box-shadow: 
    1px 0 0 rgba(0, 0, 0, 0.025),
    2px 0 0 rgba(0, 0, 0, 0.02),
    3px 0 0 rgba(0, 0, 0, 0.015),
    4px 0 0 rgba(0, 0, 0, 0.01),
    5px 0 0 rgba(0, 0, 0, 0.008),
    6px 0 0 rgba(0, 0, 0, 0.005),
    0 1px 0 rgba(0, 0, 0, 0.025),
    0 2px 0 rgba(0, 0, 0, 0.02),
    0 3px 0 rgba(0, 0, 0, 0.015),
    0 4px 0 rgba(0, 0, 0, 0.01),
    0 5px 0 rgba(0, 0, 0, 0.008),
    0 6px 0 rgba(0, 0, 0, 0.005) !important;
  border-width: 0px 0px 1px 1px !important;
  font-weight: 700;
  background-image: repeating-linear-gradient(-30deg, #E2E6E5 0, #E2E6E5 12px, white 1px, white 50%) !important;
}
